import React, { useEffect, useRef, useState } from 'react';
import IntlMessages from '@projectK/helpers/IntlMessages';
import * as yup from 'yup';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import PropTypes from 'prop-types';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { useToast } from '@projectK/context/ToastProvider';
import { AddMemberModalMain } from '@projectK/MainComponents';
const validationSchema = yup.object({
  first_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.firstName.noSpaces' />)
    .required(<IntlMessages id='validation.firstNameRequired' />),
  last_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.lastName.noSpaces' />)
    .required(<IntlMessages id='validation.lastNameRequired' />),
  role_id: yup
    .string()
    .required(<IntlMessages id='validation.userTypeRequired' />),
  calendar_color_code: yup.string().required(<IntlMessages id='validation.colorCode' />),
});

const customScrollbarStyle = {
  // Define the styles for the scrollbar
  '&::-webkit-scrollbar': {
    width: '8px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#44444461', // Lighter black color
    borderRadius: '8px', // Curved border
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#666', // Lighter black color on hover
  },
};

const AddAccountMembers = ({ isOpen, onClose, fetchMembersData }) => {
  const { verbiageSettings } = useApplicationSettings();
  const { isMobile, mobileMode } = useMobileSettings();
  const showToast = useToast();
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [roleOptions, setRoleOptions] = useState([]);
  const [color, setColor] = useState('');
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  useEffect(() => {
    fetchInstructorUsersData();
  }, []);
  const pickerRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowColorPicker(false);
      }
    }
    if (showColorPicker) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showColorPicker]);
  const { user } = useAuthUser();
  const fetchInstructorUsersData = async () => {
    try {
      const response = await jwtAxios.get(`/roles`);
      const { data } = response;
      setRoleOptions(data.list);
    } catch (error) {
      setRoleOptions([]);
    }
  };
  const handleFocus = () => {
    setShowColorPicker(true); // Show the color picker when the input field is focused
  };

  const handleColorBlur = (event) => {
    setShowColorPicker(false);
  };
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    onClose();
    setColor('');
  };
  return (
    <AddMemberModalMain
      isOpen={isOpen}
      fetchMembersData={fetchMembersData}
      handleDialogOpen={handleDialogOpen}
      validationSchema={validationSchema}
      user={user}
      handleCloseModalDialog={handleCloseModalDialog}
      isMobile={isMobile}
      infoViewActionsContext={infoViewActionsContext}
      companyTheme={companyTheme}
      verbiageSettings={verbiageSettings}
      handleFocus={handleFocus}
      handleColorBlur={handleColorBlur}
      showColorPicker={showColorPicker}
      setShowColorPicker={setShowColorPicker}
      color={color}
      setColor={setColor}
      pickerRef={pickerRef}
      openDialog={openDialog}
      handleCloseDialog={handleCloseDialog}
      customScrollbarStyle={customScrollbarStyle}
      roleOptions={roleOptions}
      onClose={onClose}
      showToast={showToast}
      mobileMode={mobileMode}
    />
  );
};

AddAccountMembers.propTypes = {
  fetchMembersData: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};
export default AddAccountMembers;
